/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_Placeholder_TooltipInputs */

const en_mail_compose_placeholder_tooltip = /** @type {(inputs: Mail_Compose_Placeholder_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-click: insert at the cursor and copy to the clipboard`)
};

const de_mail_compose_placeholder_tooltip = /** @type {(inputs: Mail_Compose_Placeholder_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelklick: an der Cursorposition einfügen und in die Zwischenablage kopieren`)
};

/**
* | output |
* | --- |
* | "Double-click: insert at the cursor and copy to the clipboard" |
*
* @param {Mail_Compose_Placeholder_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_placeholder_tooltip = /** @type {((inputs?: Mail_Compose_Placeholder_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_Placeholder_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_placeholder_tooltip(inputs)
	return en_mail_compose_placeholder_tooltip(inputs)
});